<form class="w100" [formGroup]="basicForm">
    <div class="row gap-8 avatareditarea">
        <rr-user-avatar [user]="user" class="avatar"></rr-user-avatar>
        <rr-icon
            name="edit"
            class="edit"
            routerLink="/home/account"
            [queryParams]="{ 'edit-avatar': true }"
        ></rr-icon>
    </div>
    <div class="contentarea row gap-32 w100">
        <div class="col gap-16 leftside">
            <h3>{{ user.prename || user.email }} {{ user.lastname || "" }}</h3>
            <rr-input label="First Name" formControlName="prename"></rr-input>
            <rr-input label="Last Name" formControlName="lastname"></rr-input>
            <rr-select
                label="System Language"
                [options]="languageOptions"
                optionName="name"
                formControlName="lang"
                optionValue="id"
            ></rr-select>
            <div class="col w100">
                <div class="row changeemail space-between w100">
                    <div class="row align-center">
                        <rr-icon name="email" class="circle"></rr-icon>
                        <div class="col">
                            <div class="small strong" i18n>Change Email</div>
                            <span i18n class="tiny"
                                >Your email address is {{ user.email }}</span
                            >
                        </div>
                    </div>
                    <span
                        i18n
                        class="link changelink"
                        (click)="changeEmailShow()"
                        >Change</span
                    >
                </div>
                <div class="row privacy space-between w100">
                    <div class="row align-center">
                        <rr-icon name="alert" class="circle"></rr-icon>
                        <div class="col">
                            <div class="small strong" i18n>
                                Privacy Preferences
                            </div>
                            <span i18n class="tiny"
                                >These settings are tied to your browser</span
                            >
                        </div>
                    </div>
                    <span class="link changelink">Manage</span>
                </div>
            </div>
        </div>
    </div>
</form>
